<template>
  <transition mode="out-in" name="fade">
    <template v-if="props.value">
      <div :class="props.inPlace ? 'loader loader--in-place' : 'loader'" key="_loader">
        <div class="sk-circle">
          <div class="sk-circle1 sk-child"/>
          <div class="sk-circle2 sk-child"/>
          <div class="sk-circle3 sk-child"/>
          <div class="sk-circle4 sk-child"/>
          <div class="sk-circle5 sk-child"/>
          <div class="sk-circle6 sk-child"/>
          <div class="sk-circle7 sk-child"/>
          <div class="sk-circle8 sk-child"/>
          <div class="sk-circle9 sk-child"/>
          <div class="sk-circle10 sk-child"/>
          <div class="sk-circle11 sk-child"/>
          <div class="sk-circle12 sk-child"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <slot/>
      </div>
    </template>
  </transition>
</template>

<script setup>
  const props = defineProps({
    value: {
      type: Boolean,
      default: false,
    },
    inPlace: {
      type: Boolean,
      default: false,
    },
  });
</script>


